import { render, staticRenderFns } from "./SalesClosuresTable.vue?vue&type=template&id=2e673ff8&scoped=true"
import script from "./SalesClosuresTable.vue?vue&type=script&lang=js"
export * from "./SalesClosuresTable.vue?vue&type=script&lang=js"
import style0 from "./SalesClosuresTable.scoped.css?vue&type=style&index=0&id=2e673ff8&prod&scoped=true&lang=css&external"
import style1 from "./SalesClosuresTable.global.css?vue&type=style&index=1&prod&lang=css&external"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2e673ff8",
  null
  
)

export default component.exports